import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { DateInput, TimeInput } from 'semantic-ui-calendar-react';
import { Button, Checkbox } from 'semantic-ui-react';
import { UIDateFormat, UITimeFormat } from '../../config/dates';
import SummaryButton from '../shared/SummaryButton';

const KioskFilters = (props) => {

    const { fromDate, currentDate, toDate, loading, includeEvents } = props.data;
    const { showSummary, disabled, handleChange, onSummaryClick } = props;

    const handleDateChange = (event, { name, value }) => {
        const date = moment(value, UIDateFormat);
        date.set({
            hour: props.data[name].get('hour'),
            minute: props.data[name].get('minute'),
            second: props.data[name].get('second'),
        })

        handleChange(name, date);
    }

    const handleTimeChange = (event, { name, value }) => {
        const date = props.data[name];
        const time = moment(`${date.format(UIDateFormat)} ${value}`, `${UIDateFormat} HH:mm:ss`);
        handleChange(name, time);
    }
    
    const handleCheckboxChange = (event, { name }) => handleChange(name, !props.data[name])

    return (
        <form onSubmit={(e) => { e.preventDefault() }} className="ui form">

            <SummaryButton
                active={showSummary}
                disabled={loading || disabled}
                onClick={onSummaryClick}
                className="mr-1"
            />

            From:
            <DateInput
                className="ui input ml-1"
                style={{ width: '9em' }}
                name="fromDate"
                placeholder="Date"
                value={fromDate.format(UIDateFormat)}
                iconPosition="left"
                onChange={handleDateChange}
                animation="fade"
                popupPosition="bottom center"
                closable
                autoComplete="off"
            />
            <TimeInput
                className="ui input"
                style={{ width: '6em' }}
                name="fromDate"
                placeholder="Time"
                value={fromDate.format(UITimeFormat)}
                iconPosition="left"
                onChange={handleTimeChange}
                animation="fade"
                popupPosition="bottom center"
                closable
                autoComplete="off"
            />

            {!currentDate && <span name="toDateTime">
                <label className="ml-1 ui">To:</label>
                <DateInput
                    className="ui input ml-1"
                    style={{ width: '9em' }}
                    name="toDate"
                    placeholder="Date"
                    value={toDate.format(UIDateFormat)}
                    iconPosition="left"
                    onChange={handleDateChange}
                    animation="fade"
                    popupPosition="bottom center"
                    closable
                    autoComplete="off"
                />
                <TimeInput
                    className="ui input"
                    style={{ width: '6em' }}
                    name="toDate"
                    placeholder="Time"
                    value={toDate.format(UITimeFormat)}
                    iconPosition="left"
                    onChange={handleTimeChange}
                    animation="fade"
                    popupPosition="bottom center"
                    closable
                    autoComplete="off"
                />
            </span>}
            <Checkbox className="ml-1" name="currentDate" label="Current Date/Time" checked={currentDate} onChange={handleCheckboxChange} />
            <Checkbox name="includeEvents" checked={includeEvents} onChange={handleCheckboxChange} label="Show Events" className="ml-1 mr-1" />
            <Button disabled={loading || disabled} onClick={props.onRefresh} positive>Refresh</Button>
        </form>
    );
}
const mapStateToProps = state => {
    return {
        filters: state.kioskFilters,
        data: state.kiosk.filters
    };
}
export default connect(mapStateToProps)(KioskFilters)